const getToken = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ApiKey: "r8FjiR1HwKEjav5oABYcaWNVtXQ9SE5xnVyQBzfxmisbSIjW5I",
    },
  };
  return await fetch(
    "https://easyai-backend-prag5rdboa-ew.a.run.app/Dify/getToken",
    requestOptions
  )
    .then((response) => response.text())
    .then((data) => {
      return data;
    });
};

const getDifyAssistants = async () => {
  var token = await getToken();
  var compiledToken = "Bearer " + token;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: compiledToken,
    },
  };
  return await fetch(
    "https://dify.dgtlassist.app/console/api/installed-apps",
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
};

const getDifyAssistant = async (id) => {
  var token = await getToken();
  var compiledToken = "Bearer " + token;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: compiledToken,
    },
  };
  return await fetch(
    "https://dify.dgtlassist.app/console/api/apps/" + id,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
};
export { getDifyAssistants, getDifyAssistant };
